// Centralized product data for Midtrans integration
// Harga dalam Rupiah (number) untuk Midtrans API

export interface Product {
    id: string;
    name: string;
    description: string;
    price: number; // Harga dalam Rupiah (e.g., 669000)
    displayPrice: string; // Format display (e.g., "IDR 669.000")
    originalPrice: string;
    image: string;
    category: 'prompt-gen' | 'workflow' | 'account';
    features?: string[];
}

export const products: Product[] = [
    {
        id: 'google-ai-pro',
        name: 'Google AI Pro 1 Tahun Plan',
        description: 'Percepat alur kerja dengan akses yang lebih tinggi',
        price: 149000,
        displayPrice: 'IDR 149.000',
        originalPrice: 'IDR 3.099.000',
        image: '/google-ai-pro.png',
        category: 'account',
        features: [
            'Privat - Menggunakan Mail Pribadi',
            'Google AI Pro (Gemini Pro, Veo3.1, Antigravity)',
            'Produk AI Google lainnya',
            '5TB Free Cloud',
            '1 Tahun Plan',
        ],
    },
    {
        id: 'google-ai-ultra',
        name: 'Google AI Ultra Privat | 25000 KREDIT',
        description: 'Gemini AI Pro | Google AI Pro Privat | VEO 3.1. Akses langsung ke teknologi canggih Google!',
        price: 769000,
        displayPrice: 'IDR 769.000',
        originalPrice: 'IDR 3.849.000',
        image: '/googleaiultra-baru.png',
        category: 'account',
        features: [
            '25.000 Kredit Premium',
            'Akun Pribadi (Bukan Sharing)',
            'All Device Support',
            'Akses Veo 3.1',
            'Gemini Pro',
            'Google Flow',
            'Whisk',
            'Nano Banana Pro',
        ],
    },
    {
        id: 'higgsfield-ai',
        name: 'HIGGSFIELD AI 1200C',
        description: 'Teknologi pergerakan video AI paling halus untuk kreator profesional',
        price: 1248000,
        displayPrice: 'IDR 1.248.000',
        originalPrice: 'IDR 1.499.000',
        image: '/higgsfield-baru.png',
        category: 'account',
        features: [
            '1200 Kredit Premium',
            'Akun Pribadi (Bukan Sharing)',
            'Garansi Full 30 Hari',
            'Motion video AI terbaik',
        ],
    },

    {
        id: 'kelas-ai',
        name: 'Belajar AI - Ikhsanztech-studio.',
        description: 'Frustrasi karena hasil generate AI visualmu masih terlihat kaku dan selalu inkonsisten? Di kelas Belajar AI - Ikhsanztech-studio kamu akan dibimbing langsung oleh Ikhsanztech-studio untuk menghancurkan batasan AI look dan menciptakan karya visual yang hyper-realistic yang jauh dari kesan buatan AI.',
        price: 599000,
        displayPrice: 'IDR 599.000',
        originalPrice: 'IDR 1.499.000',
        image: '/wa-group-thumb.jpg',
        category: 'account',
        features: [
            'Modul workflow lengkap untuk membuat karakter video AI konsisten & cinematic',
            'Skills Generator siap pakai untuk memudahkan dalam pembuatan prompting',
            'Diskusi privat langsung bersama Ikhsanztech-studio. — Seputar AI Filmmaker, AI Influencer, UGC Konten, AI Affiliate, dan AI Visual lainnya',
            'Lifetime Access (Akses Seumur Hidup)',
        ],
    },

    {
        id: 'ai-influencer-builder',
        name: 'Skill Generator: AI Influencer Character Builder',
        description: 'AI-influencer-builder adalah skill generator yang sudah kami rancang untuk memudahkan anda dalam pembuatan base karakter khususnya ai influencer yang hyper realistic dan no ai look.',
        price: 149000,
        displayPrice: 'IDR 149.000',
        originalPrice: 'IDR 349.000',
        image: '/ai-influencer-builder.png',
        category: 'prompt-gen',
        features: [
            'Karakter Hyperrealistic',
            'Cukup drag & drop',
            'Support ALL LLM',
            'Lifetime Access',
        ],
    },
    {
        id: 'ai-influencer-video-builder',
        name: 'Skill Generator: AI Influencer Video Builder',
        description: 'AI-influencer-video-builder adalah skill generator yang sudah kami rancang untuk memudahkan anda dalam pembuatan video ai influencer with lypsnc yang tetap natural dan tidak terlihat dibuat menggunakan ai.',
        price: 189000,
        displayPrice: 'IDR 189.000',
        originalPrice: 'IDR 449.000',
        image: '/ai-influencer-video-builder.png',
        category: 'prompt-gen',
        features: [
            'Cocok untuk : AI Influencer affiliate style, UGC, & Podcast style.',
            'Cukup drag & drop',
            'Support ALL LLM',
            'Lifetime Access',
        ],
    },
    {
        id: 'ai-influencer-character-matching',
        name: 'Skill Generator: AI Influencer Character Matching',
        description: 'Character-matching-builder adalah skill generator yang sudah kami rancang untuk memudahkan anda dalam meniru pose/adegan, mood, color grading, lighting, tempat dan lainnya dari reference image yang ingin kalian tiru.',
        price: 129000,
        displayPrice: 'IDR 129.000',
        originalPrice: 'IDR 249.000',
        image: '/ai-influencer-character-matching.png',
        category: 'prompt-gen',
        features: [
            'Base karakter tetap konsisten',
            'Cukup drag & drop',
            'Support ALL LLM',
            'Lifetime Access',
        ],
    },
    {
        id: 'ai-affiliate-unboxing-asmr',
        name: 'Skill Generator: AI Affiliate Unboxing ASMR Video',
        description: 'affiliate-unboxing asmr-builder adalah skill generator yang sudah kami rancang untuk memudahkan anda dalam pembuatan konten affiliate unboxing asmr, jadi mempercepat dalam pembuatan konten AI affiliate anda.',
        price: 99000,
        displayPrice: 'IDR 99.000',
        originalPrice: 'IDR 149.000',
        image: '/ai-affiliate-unboxing-asmr.png',
        category: 'prompt-gen',
        features: [
            'Include sheet produk prompt',
            'Include storyboard produk prompt',
            'Include video produk prompt',
            'Cukup drag & drop',
            'Support ALL LLM',
            'Lifetime Access',
        ],
    },
    {
        id: 'ai-influencer-motion-builder',
        name: 'Skill Generator: AI Influencer Motion Builder',
        description: 'AI-Influencer-Motion-Builder adalah skill generator yang sudah kami rancang untuk memudahkan Anda dalam pembuatan video AI influencer khususnya untuk meniru adegan suatu reference video, mau itu dance, adegan sebuah video dan lainnya yang pastinya tetap natural, konsistensi karakter terjaga dan tidak terlihat dibuat menggunakan AI.',
        price: 149000,
        displayPrice: 'IDR 149.000',
        originalPrice: 'IDR 249.000',
        image: '/ai-influencer-motion-builder.png',
        category: 'prompt-gen',
        features: [
            'Cocok untuk : AI Influencer affiliate style',
            'Cukup drag & drop',
            'Support ALL LLM',
            'Lifetime Access',
        ],
    },
    {
        id: 'outfit-swap-builder',
        name: 'Skill Generator: Outfit Swap Builder',
        description: 'Outfit-Swap-Builder adalah skill generator yang sudah kami rancang untuk memudahkan Anda dalam mengganti wardrobe atau outfit karakter AI tanpa mengubah detail karakter.',
        price: 149000,
        displayPrice: 'IDR 149.000',
        originalPrice: 'IDR 249.000',
        image: '/outfit-swap-builder.png',
        category: 'prompt-gen',
        features: [
            'Cocok untuk : AI Influencer affiliate style, UGC, & Podcast style.',
            'Cukup drag & drop',
            'Support ALL LLM',
            'Lifetime Access',
        ],
    },
    {
        id: 'short-ads-workflow',
        name: 'Short Ads/Film Workflow',
        description: 'Pelajari rahasia membuat iklan pendek dan film cinematic yang konsisten mulai dari karakter, storyboard hingga moodboard yang pas untuk project kalian menggunakan AI Visuals.',
        price: 129000,
        displayPrice: 'IDR 129.000',
        originalPrice: 'IDR 269.000',
        image: '/products/thumbnail-short-ads.png',
        category: 'workflow',
        features: [
            'Semua jenis project',
            'Include struktur prompt',
            'Storyboard',
            'Full breakdown & tutor',
            'Lifetime access',
        ],
    },

    {
        id: 'konsisten-karakter-workflow',
        name: 'Workflow Konsisten Karakter Untuk Scane Apapun',
        description: 'Workflow ini membahas proses lengkap untuk menjaga konsistensi karakter, mulai dari prompt structure, base character, multiple angle, hingga penerapan karakter ke berbagai scene agar tetap konsisten. Sistem ini bisa kamu aplikasikan ke berbagai project AI seperti brand ads, campaign visual, film-style content, dan kebutuhan kreatif lainnya.',
        price: 129000,
        displayPrice: 'IDR 129.000',
        originalPrice: 'IDR 269.000',
        image: '/products/thumbnail-konsisten-karakter.png',
        category: 'workflow',
        features: [
            'Semua jenis project',
            'Include struktur prompt',
            'Full breakdown & tutor',
            'Lifetime access',
        ],
    },
    {
        id: 'foto-product-workflow',
        name: 'Workflow Rahasia Foto Product ala Studio Mahal',
        description: 'Workflow ini membahas proses lengkap bagaimana rahasia foto product biar terlihat lebih profesional, konsistensi product, mulai dari prompt structure, base product, multiple angle, hingga penerapan product ke berbagai scene agar tetap konsisten. Sistem ini bisa kamu aplikasikan ke berbagai project AI seperti brand ads, campaign visual, film-style content, dan kebutuhan kreatif lainnya.',
        price: 129000,
        displayPrice: 'IDR 129.000',
        originalPrice: 'IDR 269.000',
        image: '/products/thumbnail-foto-product.png',
        category: 'workflow',
        features: [
            'Semua jenis project',
            'Include struktur prompt',
            'Full breakdown & tutor',
            'Lifetime access',
        ],
    },
    {
        id: 'base-karakter-workflow',
        name: 'Workflow Rahasia Base Karakter Ultra-Realistic',
        description: 'Dalam panduan ini, Anda akan mempelajari proses lengkap menciptakan karakter dasar (base character) beserta rahasia struktur prompt-nya. Sistem ini sangat fleksibel dan dapat diaplikasikan untuk berbagai proyek AI, terutama untuk kampanye periklanan dan konten bergaya film.',
        price: 129000,
        displayPrice: 'IDR 129.000',
        originalPrice: 'IDR 269.000',
        image: '/products/thumbnail-base-karakter.png',
        category: 'workflow',
        features: [
            'Semua jenis project',
            'Include struktur prompt',
            'Full breakdown & tutor',
            'Lifetime access',
        ],
    },
    {
        id: 'virtual-try-on-workflow',
        name: 'Rahasia Virtual Try-On Workflow',
        description: 'Dalam workflow ini, Anda akan mempelajari teknik rahasia mengganti pakaian (change outfit) pada sebuah foto menggunakan AI. Panduan ini sangat direkomendasikan bagi pemilik merek fashion yang ingin menekan biaya produksi visual secara signifikan, tanpa perlu menyewa model atau mengadakan sesi foto berulang kali.',
        price: 129000,
        displayPrice: 'IDR 129.000',
        originalPrice: 'IDR 269.000',
        image: '/products/thumbnail-virtual-try-on.png',
        category: 'workflow',
        features: [
            'Semua jenis project',
            'Include struktur prompt',
            'Full breakdown & tutor',
            'Lifetime access',
        ],
    },
    {
        id: 'nano-workflow',
        name: 'Nano Banana Workflow',
        description: 'Bongkar rahasia workflow asli dari Ikhsanztech Studio. Dari satu gambar jadi film sinematik utuh.',
        price: 49000,
        displayPrice: 'IDR 49.000',
        originalPrice: 'IDR 750.000',
        image: '/products/gambar-nano.png',
        category: 'workflow',
        features: [
            'Workflow Lengkap Step-by-Step',
            'Dari 1 Gambar ke Film',
            'Teknik Profesional',
            'Video Tutorial',
        ],
    },
    {
        id: 'speedramp-workflow',
        name: 'Speedramp Effect Workflow',
        description: 'Mindset AI Video Director dengan tutorial Nano Banana Pro. Efek cinematic profesional untuk video Anda.',
        price: 49000,
        displayPrice: 'IDR 49.000',
        originalPrice: 'IDR 899.000',
        image: '/products/gambar-speedramp.png',
        category: 'workflow',
        features: [
            'Efek Speedramp Cinematic',
            'Tutorial Video Lengkap',
            'Teknik AI Director',
            'Lifetime Access',
        ],
    },

    {
        id: 'chatgpt-plus',
        name: 'ChatGPT Plus 5.5 (1 Bulan)',
        description: 'ChatGPT Plus dengan fitur lengkap: Codex, Sora, mode agen, dan memori percakapan.',
        price: 250000,
        displayPrice: 'IDR 250.000',
        originalPrice: 'IDR 1.047.000',
        image: '/chatgpt-plus.png',
        category: 'account',
        features: [
            'Selesaikan masalah yang kompleks',
            'Lakukan obrolan panjang di beberapa sesi',
            'Buat lebih banyak gambar dengan lebih cepat',
            'Ingat tujuan dan percakapan sebelumnya',
            'Rencanakan perjalanan dan tugas dengan mode agen',
            'Atur proyek dan sesuaikan GPT Anda',
            'Buat dan bagikan video di Sora',
            'Tulis kode dan buat aplikasi dengan Codex',
        ],
    },
    {
        id: 'adobe-cc-pro',
        name: 'Adobe Creative Cloud Pro - 4 Bulan',
        description: '',
        price: 349000,
        displayPrice: 'IDR 349.000',
        originalPrice: 'IDR 1.384.320',
        image: '/adobe-ai-pro.png',
        category: 'account',
        features: [
            'Akun Privat',
            'Adobe Firefly to access AI Tools 16.000 Kredit',
            'Akses ke 20+ Aplikasi Profesional: Photoshop, Illustrator, Premiere Pro, After Effects, InDesign, dan Lightroom',
            '100GB Cloud Storage',
            '4 Bulan Plan',
        ],
    },
];

// Helper function to get product by ID
export function getProductById(id: string): Product | undefined {
    return products.find(product => product.id === id);
}

// Helper function to get products by category
export function getProductsByCategory(category: Product['category']): Product[] {
    return products.filter(product => product.category === category);
}
